import Support, { getStaticProps } from 'routes/Support'

export { getStaticProps }

export default Support
